<ng-container *transloco="let t">
  <div class="flex h-full flex-col gap-4">
    @if (strategyGroup()) {
      <div>
        @let blacklistLength = strategyGroup()!.blacklist?.length ?? 0;
        <div class="flex flex-col gap-2">
          <div class="flex items-center justify-between">
            <div class="flex items-center gap-2">
              <div class="font-medium text-gray-600">
                {{ t("common.blacklist") }}
                <IBadge class="ml-1 align-bottom" [label]="blacklistLength + ''" color="gray" />
              </div>

              @if (blacklistLength > 0) {
                <button iButton variant="ghost" size="icon-sm" (click)="isBlacklistOpen.set(!isBlacklistOpen())">
                  <IIcon [name]="isBlacklistOpen() ? 'chevronDown' : 'chevronRight'" />
                </button>
              }
            </div>

            <button iButton variant="secondary" [disabled]="isReadOnly()" (click)="openBlackListEditionModal()">
              <IIcon name="editSquare" />
              {{
                blacklistLength > 0
                  ? t("sp-strategy-group-page.edit_blacklist")
                  : t("sp-strategy-group-page.create_blacklist")
              }}
            </button>
          </div>
        </div>
        <IAccordion [isOpen]="isBlacklistOpen()">
          @if (blacklistLength >= MAX_BLACKLIST_ITEMS) {
            <div class="mb-2 p-px">
              <IAlert
                type="warning"
                [title]="t('sp-strategy-group-page.you_have_reached_the_max_number_of_blacklist_items')"
              />
            </div>
          }

          <app-blacklist-view [blacklist]="strategyGroup()!.blacklist ?? []"></app-blacklist-view>
        </IAccordion>
      </div>
      @let brandStrategiesLength = strategyGroup()!.brandStrategies.length;
      <div class="flex flex-col gap-2" [ngClass]="{ 'flex-1': brandStrategiesLength > 0 }">
        <div class="flex items-center justify-between">
          <div class="font-medium text-gray-600">
            {{ t("sp-strategy-group-page.brand_defense_strategies") }}
            <IBadge class="ml-1 align-bottom" [label]="strategyGroup()!.brandStrategies.length + ''" color="gray" />
          </div>

          <button
            iButton
            variant="secondary"
            [disabled]="isReadOnly()"
            (click)="openSubStrategyCreationPage(StrategyType.BRAND)"
          >
            <IIcon name="add" />
            {{ t("sp-strategy-group-page.add_a_new_brand_defense_strategy") }}
          </button>
        </div>

        @if (brandStrategiesLength > 0) {
          <div class="ag-theme-quartz flex-1">
            <ag-grid-angular
              class="h-full"
              [gridOptions]="brandStrategyGridOptions"
              [rowData]="strategyGroup()!.brandStrategies"
              [rowDragManaged]="true"
              #brandStrategies
            />
          </div>
        }
      </div>

      @let keywordStrategiesLength = strategyGroup()!.keywordStrategies.length;
      <div class="flex flex-col gap-2" [ngClass]="{ 'flex-1': keywordStrategiesLength > 0 }">
        <div class="flex items-center justify-between">
          <div class="font-medium text-gray-600">
            {{ t("sp-strategy-group-page.focus_strategies") }}
            <IBadge class="ml-1 align-bottom" [label]="keywordStrategiesLength + ''" color="gray" />
          </div>

          <button
            iButton
            variant="secondary"
            [disabled]="isReadOnly()"
            (click)="openSubStrategyCreationPage(StrategyType.KEYWORD)"
          >
            <IIcon name="add" />
            {{ t("sp-strategy-group-page.add_a_new_focus_strategy") }}
          </button>
        </div>

        @if (keywordStrategiesLength > 0) {
          <div class="ag-theme-quartz flex-1">
            <ag-grid-angular
              class="h-full"
              [gridOptions]="keywordStrategyGridOptions"
              [rowData]="strategyGroup()!.keywordStrategies"
              [rowDragManaged]="true"
              #keywordStrategies
            />
          </div>
        }
      </div>

      @if (strategyGroup()!.productStrategies.length > 0) {
        <div class="flex flex-1 flex-col gap-2">
          <div class="flex items-center justify-between">
            <div class="font-medium text-gray-600">
              {{ t("sp-strategy-group-page.main_strategies") }}
              <IBadge class="ml-1 align-bottom" [label]="strategyGroup()!.productStrategies.length + ''" color="gray" />
            </div>
            <button
              iButton
              variant="secondary"
              [disabled]="isReadOnly()"
              (click)="openSubStrategyCreationPage(StrategyType.PRODUCT)"
            >
              <IIcon name="add" />
              {{ t("sp-strategy-group-page.add_a_new_main_strategy") }}
            </button>
          </div>

          <div class="ag-theme-quartz flex-1">
            <ag-grid-angular
              class="h-full"
              [gridOptions]="productStrategyGridOptions"
              [rowData]="strategyGroup()!.productStrategies"
              #productStrategies
            />
          </div>
        </div>
      }
    }
  </div>
</ng-container>
